import {
	GET_PAGERDUTY_INCIDENTS_UPDATE,
	GET_PAGERDUTY_INCIDENTS_ACK_UPDATE,
	GET_PAGERDUTY_INCIDENTS_TABLE,
	TOGGLE_INCIDENT_TRACKER_DIALOG,
	TOGGLE_DELETE_INCIDENT_DIALOG,
	GET_DROPDOWNS,
	GET_INCIDENT,
	SET_FORM_STATE
} from '../actions/PagerDutyIncidentsActions.js';

const initialState = {
	incidentsLastUpdate: '',
	incidentsAckLastUpdate: '',
	incidentsTableData: [],
	dropdowns: [],
	formState: {
		values: {},
		isValid: false,
		touched: {},
		errors: {},
		submit: false
	}
};

const pagerDutyIncidentsReducer = (state = initialState, action) => {
	switch (action.type) {
					case TOGGLE_DELETE_INCIDENT_DIALOG: {
						return {
							...state,
							deleteIncidentDialogVisibility: action.visible,
							selectedIncidentId: action.incidentId
						};
					}
					case TOGGLE_INCIDENT_TRACKER_DIALOG: {
						return {
							...state,
							incidentTrackerDialogVisibility: action.visible,
							selectedIncidentId: action.incidentId,
							isIncidentClosed: action.incidentClosed,
							selectedIncidentSubmitter: action.incidentSubmitter,
							formState: initialState.formState,
							dropdowns: initialState.dropdowns,
							projectsDropdown: initialState.projectsDropdown,
							sowDropdown: initialState.sowDropdown,
							layersDropdown: initialState.layersDropdown,
							typeDropdown: initialState.typeDropdown,
							detailedTypeDropdown: initialState.detailedTypeDropdown,
							currentQueueDropdown: initialState.currentQueueDropdown
						};
					}
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case GET_DROPDOWNS: {
						return {
							...state,
							dropdowns: action.dropdowns
						};
					}
					case GET_INCIDENT: {
						return {
							...state,
							formState: {
								...state.formState,
								values: { ...action.incident }
							}
						};
					}
					case GET_PAGERDUTY_INCIDENTS_UPDATE: {
						return {
							...state,
							incidentsLastUpdate: action.incidentsLastUpdate
						};
					}
					case GET_PAGERDUTY_INCIDENTS_ACK_UPDATE: {
						return {
							...state,
							incidentsAckLastUpdate: action.incidentsAckLastUpdate
						};
					}
					case GET_PAGERDUTY_INCIDENTS_TABLE: {
						return {
							...state,
							incidentsTableData: action.incidentsTableData
						};
					}
					default: {
						return state;
					}
	}
};

export default pagerDutyIncidentsReducer;
